import { render } from "./HomeLogged.vue?vue&type=template&id=55a46f4f&scoped=true"
import script from "./HomeLogged.vue?vue&type=script&lang=js"
export * from "./HomeLogged.vue?vue&type=script&lang=js"

import "./HomeLogged.vue?vue&type=style&index=0&id=55a46f4f&scoped=true&lang=css"

import exportComponent from "E:\\coding\\pharaoh_frog_barber\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55a46f4f"]])

export default __exports__